import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { TrendingUp, TrendingDown } from "@mui/icons-material";

// Import child components
import PageHeader from "../../components/buyer/market/PageHeader.jsx";
import CountrySelector from "../../components/buyer/market/CountrySelector.jsx";
import HighlightCards from "../../components/buyer/market/HighlightCards.jsx";
import MarketTabs from "../../components/buyer/market/MarketTabs.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getPriceExchangeRate } from "../../features/user/userSlice.js";

const currencyMap = {
  UK: "GBP",
  China: "CNY",
  Dubai: "AED",
  Japan: "JPY",
  India: "INR",
};

const unitMap = [
  { label: "Kilogram (kg)", value: "kg" },
  { label: "Metric Ton (mt)", value: "mt" },
];

// const currencySymbols = {
//   INR: "₹",
//   AED: "د.إ",
//   CNY: "¥",
//   JPY: "¥",
//   USD: "$",
//   // EUR: "€"
// };

const MarketPage = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState({ field: "metal  ", direction: "asc" });
  const [country, setCountry] = useState("Global");
  const [unit, setUnit] = useState(unitMap[0].value);
  const isLoggedIn = useSelector((state) => !!state.auth.token);

  const theme = useTheme();

  const { priceExchangeRate, priceExchangeRateLoading } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    // If country is Global, call API without param
    const countryCode =
      country === "Global" ? "USD" : currencyMap[country];
    dispatch(getPriceExchangeRate({ currency: countryCode, unit: unit }));
  }, [dispatch, country,unit]);

  // Sorting handler
  const handleSort = (field) => {
    const isAsc = sortBy.field === field && sortBy.direction === "asc";
    setSortBy({ field, direction: isAsc ? "desc" : "asc" });
  };

  // Get current country data
  const currentCountryData = priceExchangeRate?.data || {};

  // console.log("Price Exchange Rate:", priceExchangeRate);
  // console.log("Current Country Data:", currentCountryData);

  // Filter + sort
  // const filteredData = currentCountryData
  //   .filter((item) => {
  //     // Search filter
  //     const matchesSearch = (item.metal || "")
  //       .toLowerCase()
  //       .includes(searchTerm.toLowerCase());

  //     // If Global, only keep USD data
  //     const isGlobalUsd = country === "Global" ? item.currency === "USD" : true;

  //     return matchesSearch && isGlobalUsd;
  //   })
  //   .sort((a, b) => {
  //     let valA = a[sortBy.field === "material" ? "metal" : sortBy.field];
  //     let valB = b[sortBy.field === "material" ? "metal" : sortBy.field];

  //     if (sortBy.field === "price" || sortBy.field === "change") {
  //       valA = parseFloat(valA);
  //       valB = parseFloat(valB);
  //     }

  //     if (valA < valB) return sortBy.direction === "asc" ? -1 : 1;
  //     if (valA > valB) return sortBy.direction === "asc" ? 1 : -1;
  //     return 0;
  //   });

  // const countryVolumeData =
  //   country === "Global"
  //     ? currentCountryData.filter((item) => item.currency === "USD")
  //     : currentCountryData.filter(
  //         (item) => item.currency === currencyMap[country]
  //       );

  // Helper functions

  const getChangeColor = (change) => {
    if (change == null) return theme.palette.error.main; // fallback

    // Remove % if present and parse
    const numeric = parseFloat(String(change).replace("%", "").trim());

    return numeric > 0 ? theme.palette.success.main : theme.palette.error.main;
  };

  const getChangeIcon = (change) => {
    if (change == null) return null;
    const numeric = parseFloat(String(change).replace("%", "").trim());
    return numeric > 0 ? (
      <TrendingUp sx={{ fontSize: 16 }} />
    ) : (
      <TrendingDown sx={{ fontSize: 16 }} />
    );
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${theme.palette.grey[50]} 0%, #e3f2fd 100%)`,
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        {/* Page Header */}
        <PageHeader />

        {/* Country Selector */}
        <CountrySelector
          country={country}
          setCountry={setCountry}
          currencyMap={currencyMap}
          unitMap={unitMap}
          setUnit={setUnit}
          unit={unit}
        />

        {/* Highlight Cards */}
        <HighlightCards
          Cards
          currentCountryData={currentCountryData}
          // currencySymbols={currencySymbols}
        />

        {/* Main Content with Tabs */}
        <MarketTabs
          country={country}
          currentCountryData={currentCountryData}
          // countryVolumeData={countryVolumeData}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          // filteredData={filteredData}
          sortBy={sortBy}
          handleSort={handleSort}
          getChangeColor={getChangeColor}
          getChangeIcon={getChangeIcon}
          // currencySymbols={currencySymbols}
          isLoggedIn={isLoggedIn}
        />
      </Container>
    </Box>
  );
};

export default MarketPage;
